import React from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import './OptimizationResult.css';

const OptimizationResult = ({
  originData,
  data,
  onConfirm,
  onReject,
  onClose,
}) => {
  const originMappedData = data.reduce((acc, val) => {
    const route = originData.find(item => item.id == val.id);
    acc[val.id] = {
      distance: route.distance,
      duration: route.duration,
      stopsLength: route.stops.length,
    };
    return acc;
  }, {});
  const getDifference = (originValue, currentValue, delimiter = 1) => {
    if (originValue === currentValue) {
      return '(0)';
    }
    return `(${originValue > currentValue ? '-' : '+'}${Math.round(
      Math.abs(originValue - currentValue) / delimiter
    )})`;
  };
  return (
    <div className="container optimization-result">
      <div className="flex flex-row-end">
        <IconButton
          color="primary"
          size="small"
          className="close-btn"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <h3>Optimization completed.</h3>
      </div>
      <div>
        {data.map(route => (
          <div className="optimised-route" key={route.id}>
            Route <span>{route.id}</span> length is{' '}
            <b>
              {Math.round(route.distance / 1609.34)} miles
              <i>
                {getDifference(
                  originMappedData[route.id].distance,
                  route.distance,
                  1609.34
                )}
              </i>
            </b>
            , it takes{' '}
            <b>
              {Math.round(route.duration / 60)} min
              <i>
                {getDifference(
                  originMappedData[route.id].duration,
                  route.duration,
                  60
                )}
              </i>
            </b>
            &nbsp; and contains{' '}
            <b>
              {route.stops.length}
              <i>
                {getDifference(
                  originMappedData[route.id].stopsLength,
                  route.stops.length
                )}
              </i>{' '}
              stops
            </b>
            .
          </div>
        ))}
      </div>
      <div className="flex flex-row-end buttons">
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onConfirm}
        >
          Confirm
        </Button>
        <Button color="primary" size="small" onClick={onReject}>
          Reject
        </Button>
      </div>
    </div>
  );
};

export default OptimizationResult;
